import type { Database } from '../../types/database';
import type { PillStatus } from '../primitives/Pill';

export type ProjectRow = Database['public']['Tables']['projects']['Row'];
export type WorkItemRow = Database['public']['Tables']['work_items']['Row'];
export type DocumentRow = Database['public']['Tables']['documents']['Row'];
export type ArtifactRow = Database['public']['Tables']['project_artifacts']['Row'];
export type WorkItemDependencyRow =
  Database['public']['Tables']['work_item_dependencies']['Row'];

/** One Definition-of-Done criterion (parsed from `projects.definition_of_done` jsonb). */
export interface DodCriterion {
  id: string;
  text: string;
  met: boolean;
  position: number;
}

/** A document joined with its resolved type key + name. */
export interface ProjectDocument extends DocumentRow {
  typeKey: string;
  typeName: string;
}

/** A work item enriched with its display pill + completed flag. */
export interface ProjectWorkItem extends WorkItemRow {
  pill: PillStatus;
  isCompleted: boolean;
}

/** Lowercased statuses that count as "done" for progress. */
export const COMPLETED_STATUSES: ReadonlySet<string> = new Set([
  'done',
  'shipped',
  'complete',
  'completed'
]);

/** Work-item types shown in the flat Work Items gallery (epics + subtasks excluded). */
export const GALLERY_WORK_ITEM_TYPES: ReadonlySet<string> = new Set([
  'story',
  'bug',
  'task'
]);
